import React, { useEffect } from "react";
import { observer, inject } from "mobx-react";
import { withRouter } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { TARIFFS_MAIN_PAGE_QUERY } from "Services/queries";
import { useWithDefaultParams } from "Services/useWithDefaultParams";
import { Tariffication404 } from "ComponentsUI/Components404";

const ProfitableTariffsCarousel = (props) => {
	let {
		ApplicationModel: {
			windowSizeModel: { windowSizes },
			currentRegion,
			text,
		},
		location: { pathname },
	} = props;

	let urlRegion = pathname.split("/")?.[1];
	let match = useWithDefaultParams(urlRegion);
	let regionUrl = match.params.regionUrl;

	let mainTariifsQuery = useQuery(TARIFFS_MAIN_PAGE_QUERY, {
		skip: !regionUrl,
		variables: {
			region_url: regionUrl,
		},
		notifyOnNetworkStatusChange: true,
	});
	let mainTariifs = mainTariifsQuery?.data?.tariffsMainPage?.data;

	let mainTariifsQueryCurrentRegion = useQuery(TARIFFS_MAIN_PAGE_QUERY, {
		skip: mainTariifsQuery.loading || !!mainTariifs?.length || !currentRegion?.url,
		variables: {
			region_url: currentRegion?.url,
		},
		notifyOnNetworkStatusChange: true,
	});
	let mainTariifsCurrentRegion = mainTariifsQueryCurrentRegion?.data?.tariffsMainPage?.data;

	useEffect(() => {
		if (windowSizes.xs && mainTariifs?.length > 4) {
			mainTariifs = mainTariifs.slice(1, 4);
		}
	}, [mainTariifsQuery?.loading, mainTariifsQueryCurrentRegion?.loading, windowSizes.xs]);

	if (!mainTariifs?.length && !mainTariifsCurrentRegion?.length) {
		return null;
	}

	let tariffs = !!mainTariifs?.length ? mainTariifs : mainTariifsCurrentRegion;
	let countOfPlans = 3;

	return (
		<Tariffication404
			windowSizes={windowSizes}
			textH2={text.h2_404}
			tariffs={tariffs.slice(0, countOfPlans)}
		/>
	);
};
export default withRouter(inject("ApplicationModel")(observer(ProfitableTariffsCarousel)));
